import { render, staticRenderFns } from "./IconASC.vue?vue&type=template&id=51c04e3e"
import script from "./IconASC.vue?vue&type=script&lang=ts"
export * from "./IconASC.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports